import { useState } from 'react';
import './Dashboard.css';

function LoginGate({ onAuth }) {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login === 'dude' && password === '1234') {
      sessionStorage.setItem('dashAuth', '1');
      onAuth();
    } else {
      setError('Wrong credentials');
    }
  };

  return (
    <div className="dashLogin">
      <form className="dashLoginForm" onSubmit={handleSubmit}>
        <h2 className="dashLoginTitle">Dashboard</h2>
        {error && <div className="dashLoginError">{error}</div>}
        <input className="dashLoginInput" type="text" placeholder="Login" value={login} onChange={e => setLogin(e.target.value)} autoFocus />
        <input className="dashLoginInput" type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
        <button className="dashLoginBtn" type="submit">Enter</button>
      </form>
    </div>
  );
}

const RANGES = ['today', 'week', 'month', 'all'];
const RANGE_LABELS = { today: 'Today', week: 'Week', month: 'Month', all: 'All time' };

const MOCK_DATA = {
  today:  { visits: 0, registrations: 0, sales: 0, revenue: 0 },
  week:   { visits: 0, registrations: 0, sales: 0, revenue: 0 },
  month:  { visits: 0, registrations: 0, sales: 0, revenue: 0 },
  all:    { visits: 0, registrations: 0, sales: 0, revenue: 0 },
};

export function Dashboard() {
  const [authed, setAuthed] = useState(sessionStorage.getItem('dashAuth') === '1');
  const [range, setRange] = useState('month');

  if (!authed) return <LoginGate onAuth={() => setAuthed(true)} />;

  const d = MOCK_DATA[range];

  return (
    <div className="dashPage">
      <div className="dashHeader">
        <h1 className="dashTitle">Dashboard</h1>
        <button className="dashLogout" onClick={() => { sessionStorage.removeItem('dashAuth'); setAuthed(false); }}>
          Logout
        </button>
      </div>

      <div className="dashRangeBar">
        {RANGES.map(r => (
          <button key={r} className={`dashRangeBtn ${r === range ? 'dashRangeBtn--active' : ''}`} onClick={() => setRange(r)}>
            {RANGE_LABELS[r]}
          </button>
        ))}
      </div>

      <div className="dashCards">
        <div className="dashCard">
          <div className="dashCardValue">{d.visits}</div>
          <div className="dashCardLabel">Visits</div>
        </div>
        <div className="dashCard">
          <div className="dashCardValue">{d.registrations}</div>
          <div className="dashCardLabel">Registrations</div>
        </div>
        <div className="dashCard">
          <div className="dashCardValue">{d.sales}</div>
          <div className="dashCardLabel">Sales</div>
        </div>
        <div className="dashCard">
          <div className="dashCardValue">${d.revenue}</div>
          <div className="dashCardLabel">Revenue</div>
        </div>
        <div className="dashCard">
          <div className="dashCardValue">
            {d.visits > 0 ? ((d.registrations / d.visits) * 100).toFixed(1) : '0.0'}%
          </div>
          <div className="dashCardLabel">Reg. Rate</div>
        </div>
        <div className="dashCard">
          <div className="dashCardValue">
            {d.registrations > 0 ? ((d.sales / d.registrations) * 100).toFixed(1) : '0.0'}%
          </div>
          <div className="dashCardLabel">Conv. Rate</div>
        </div>
      </div>
    </div>
  );
}
